/**
 * Footing — a TYPE-ONLY family (FOOTINGS round, 2026-08-09; docs/MODELER.md "WALL
 * FOOTINGS + STEM WALLS"): a curated firm-standard footing section a WALL references
 * via its `footingTypeId` instance param. No element is ever created in this category
 * — there is no draw tool, no geometry-registry entry, no handle config; the wall's
 * own generator derives the footing prisms. Width × thickness define the section;
 * `stepIncrementFt` (the vertical step quantum as grade falls) is the one topo-mode
 * rule that IS a product/practice standard, so it stays on the type.
 *
 * COVERAGE moved OFF the type (Matt, 2026-08-09, same round): required bury depth
 * below finish grade to top-of-footing is a SITE condition (frost depth) — a type
 * param would force the firm library to hold duplicate footing sizes per coverage
 * depth. It lives in the PROJECT structural settings (params.ts#StructuralSettings,
 * edited in the Modeler's Structural… modal) with a nullable per-wall override.
 */
import type { CategorySchema } from '../../registry'

export const footingSchema: CategorySchema = {
  id: 'footing',
  label: 'Footing',
  typeParams: {
    groups: [
      {
        label: 'Section',
        params: [
          { key: 'widthFt', label: 'Width', kind: 'length', default: 1.5, min: 0.5, max: 8 },
          { key: 'thicknessFt', label: 'Thickness', kind: 'length', default: 10 / 12, min: 0.25, max: 4 },
          { key: 'material', label: 'Material', kind: 'material', default: '' },
        ],
      },
      {
        label: 'Stepping',
        params: [
          {
            key: 'stepIncrementFt', label: 'Step Increment', kind: 'length', default: 2, min: 1 / 12, max: 8,
          },
        ],
      },
    ],
  },
  instanceParams: { groups: [] },
}
